import { getValidationStateFor } from '../editor/validationState.js';
import { getEl, getSocketEl } from '../dom.js';
import type { ConnectionStateController } from './connectionState.js';
import type { AppState } from '../state/appState.js';

export function applyConnectionState(connectionState: ConnectionStateController): void {
  document.querySelectorAll('.port-dot.connected').forEach(el => el.classList.remove('connected'));
  document.querySelectorAll('.port-dot.pending-anchor').forEach(el => el.classList.remove('pending-anchor'));
  connectionState.getVisibleEdges().forEach(edge => {
    const fromEl = getSocketEl(edge.fromNode, edge.fromPort, 'out');
    const toEl = getSocketEl(edge.toNode, edge.toPort, 'in');
    if (fromEl) fromEl.classList.add('connected');
    if (toEl) toEl.classList.add('connected');
  });
  const pendingConn = connectionState.pendingConn;
  if (pendingConn) {
    if (pendingConn.isFromOut && pendingConn.fromNode != null && pendingConn.fromPort != null) {
      const el = getSocketEl(pendingConn.fromNode, pendingConn.fromPort, 'out');
      if (el) el.classList.add('pending-anchor');
    } else if (!pendingConn.isFromOut && pendingConn.toNode != null && pendingConn.toPort != null) {
      const el = getSocketEl(pendingConn.toNode, pendingConn.toPort, 'in');
      if (el) el.classList.add('pending-anchor');
    }
  }
}

export function applyValidationState(appState: AppState): void {
  document.querySelectorAll('.node.has-error, .node.has-warning').forEach(el => {
    el.classList.remove('has-error', 'has-warning');
    el.removeAttribute('title');
  });

  const validation = getValidationStateFor(appState);
  for (const [nodeId, issues] of Object.entries(validation.nodeIssues)) {
    const nodeEl = getEl<HTMLElement>(`node-${nodeId}`);
    if (!nodeEl) continue;
    const hasError = issues.some(issue => issue.level === 'error');
    nodeEl.classList.add(hasError ? 'has-error' : 'has-warning');
    nodeEl.title = issues.map(issue => issue.message).join('\n');
  }
}

export function updateSelectionState(appState: AppState): void {
  document.querySelectorAll('.node.selected').forEach(el => el.classList.remove('selected'));
  const { selectedNode } = appState;
  if (!selectedNode) return;
  const selectedEl = getEl<HTMLElement>(`node-${selectedNode}`);
  if (selectedEl) selectedEl.classList.add('selected');
}
